import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import { ErrorBoundary } from '@/components/error-boundary/error-boundary';
import { ToastSystem } from '@/components/toast/toast-system';
import { useSessionVerification } from '@/hooks/use-session-verification';
import { useThemeSync } from '@/hooks/use-theme-sync';
import { AppRoutes } from '@/router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
});

function AppContent() {
  useSessionVerification();
  useThemeSync();

  return (
    <BrowserRouter>
      <AppRoutes />
      <ToastSystem />
    </BrowserRouter>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppContent />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
